import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ProductGrid } from "../components/ProductGrid";
import { Button } from "../components/Button";
import type { ProductWithImages } from "../types";
import { PRODUCT_CATEGORIES } from "../types";
import { usePageTitle } from "../hooks/usePageTitle";

export function Home() {
  usePageTitle("Home");
  const [featuredProducts, setFeaturedProducts] = useState<ProductWithImages[]>(
    []
  );
  const [randomProducts, setRandomProducts] = useState<ProductWithImages[]>([]);
  const [loading, setLoading] = useState(true);
  const [randomLoading, setRandomLoading] = useState(true);

  useEffect(() => {
    fetchFeaturedProducts();
    fetchRandomProducts();
  }, []);

  const fetchFeaturedProducts = async () => {
    try {
      const response = await fetch("/api/products?featured=true");
      if (response.ok) {
        const data = await response.json();
        setFeaturedProducts(data);
      }
    } catch (error) {
      console.error("Error fetching featured products:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRandomProducts = async () => {
    try {
      const response = await fetch("/api/products/random?limit=6");
      if (response.ok) {
        const data = await response.json();
        setRandomProducts(data);
      }
    } catch (error) {
      console.error("Error fetching random products:", error);
    } finally {
      setRandomLoading(false);
    }
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-900 to-black text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-4">Deb's Expressions</h1>
          <p className="text-xl">
            Unique gifts and decorations for every occasion
          </p>
        </div>
      </section>

      {/* Featured Products */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h2 className="text-3xl font-bold mb-8">Featured Products</h2>
        <ProductGrid products={featuredProducts} loading={loading} />
      </section>

      {/* You May Be Interested In */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h2 className="text-3xl font-bold mb-8">You May Be Interested In</h2>
        <ProductGrid products={randomProducts} loading={randomLoading} />
      </section>

      {/* Categories */}
      <section className="bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-8 text-center">Shop by Category</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {PRODUCT_CATEGORIES.map((category) => (
              <Link
                key={category.value}
                to={`/products/${category.value}`}
                className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow text-center"
              >
                <h3 className="text-xl font-semibold mb-2">{category.label}</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Browse our collection
                </p>
                <span className="text-black font-medium hover:underline">
                  Shop Now →
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
